// extracted by mini-css-extract-plugin
export default {"tag":"coinTag_tag__RMWj4"};